import { useNewCode } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Grid, GridItem } from '@calendly/ui/components/grid';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { HeadingText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { statisticsSelector } from 'features/organization_statistics';
import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants';
import { useTrack } from 'hooks/analytics_events/useTrack';
import { closeAddUserModal } from '../slice';
import { AvailableSeatsMessage } from './components/available_seats_message';
import { InviteForm } from './components/invite_form';
import { NoSeatsBanner } from './components/no_seats_banner';
import { ValuePropBanner } from './components/value_prop_banner';
const styledSheetIsAdminOnboardingExperimentCss = "s1ypdlbg";
const styledSheetIsPhoneCss = "s1g1nngd";
const styledSheetCss = "ssb9wcp";
const StyledSheet = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  const isAdminOnboardingExperiment = useNewCode('activation_q3', false)?.enabled;
  return <Sheet ref={ref} {...props} className={classNames(styledSheetCss, {
    [styledSheetIsAdminOnboardingExperimentCss]: isAdminOnboardingExperiment,
    [styledSheetIsPhoneCss]: isPhone
  }, props.className)} />;
});
const styledBareButtonCss = "s109k737";
const StyledBareButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledBareButtonCss, props.className)} />);
export const AddUsersModal = ({
  isOpen,
  onClose = () => {},
  onSuccess = () => {}
}) => {
  const track = useTrack();
  const {
    available_seats: availableSeats,
    isLoading
  } = useSelector(statisticsSelector) || 0;
  const isAdminOnboardingExperiment = useNewCode('activation_q3', false)?.enabled;
  const dispatch = useDispatch();
  const {
    pathname
  } = useLocation();
  const onCloseModal = () => {
    onClose();
    track({
      name: TRACKING_EVENT_NAMES.MODAL_INTERACTION,
      properties: {
        modal_name: 'invite_user_email_flow',
        action: 'closing',
        path: pathname
      }
    });
    dispatch(closeAddUserModal());
  };
  return <Modal isOpen={isOpen} onClose={onCloseModal}>
      <StyledSheet>
        <Grid>
          <GridItem size={11}>
            <HeadingText level={1} size="medium">
              {isAdminOnboardingExperiment ? I18n.t('publisher.add_users_modal.experiment_heading') : I18n.t('publisher.add_users_modal.heading')}
            </HeadingText>
          </GridItem>
          <GridItem size={1}>
            <StyledBareButton onClick={onCloseModal} id="invite-user-modal-close-button" aria-label="Close">
              <CloseIcon size="large" />
            </StyledBareButton>
          </GridItem>
        </Grid>
        {!isAdminOnboardingExperiment && !isLoading && availableSeats === 0 && <NoSeatsBanner />}
        <AvailableSeatsMessage availableSeats={availableSeats} />
        {isAdminOnboardingExperiment && <ValuePropBanner />}
        <InviteForm availableSeats={availableSeats} onClose={onCloseModal} inlineRoleSelect viaModal onSuccess={onSuccess} />
      </StyledSheet>
    </Modal>;
};

require("./add_users_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_users_modal.js");